import { render, staticRenderFns } from "./adminPointclouds.vue?vue&type=template&id=7a8db97a"
import script from "./adminPointclouds.vue?vue&type=script&lang=js"
export * from "./adminPointclouds.vue?vue&type=script&lang=js"
import style0 from "./adminPointclouds.vue?vue&type=style&index=0&id=7a8db97a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports